<template>
    <div class="upload-select">
        <input type="file" ref="fileToUpload" id="fileToUpload" accept="text/csv"
               @change="fileSelected" class="inputfile" multiple>
        <label class="upload-tip">注：只可以上传csv格式的文件，文件可以多选</label>
        <observation-information v-for="(item, index) in observationList" :prop-index="index"
                                 :prop-file-name="item.filename" :prop-create-time = "item.createTime"
                                 :prop-remark="item.remark" :key="'oi'+index"
                                 @updateCreateTime="handlerUpdateCreateTime"
                                 @updateRemark="handleUpdateRemark"/>
    </div>
</template>

<script>
    import XEUtils from 'xe-utils';
    import ObservationInformation from "@/components/ObservationInfomation.vue";
    export default {
        name: 'UploadSelect',
        components: {ObservationInformation},
        props: {
        },
        data() {
            return {
                observationList: [],
            }
        },
        computed: {},
        async created() {
        },
        methods: {
            fileSelected(e) {
                let files = e.target.files;
                this.observationList.length = 0;
                for(let i = 0; i < files.length; i++) {
                    let file = files[i];
                    let observation = {
                        file: file,
                        filename: file.name,
                        createTime: XEUtils.toDateString(new Date(file.lastModifiedDate), 'yyyy-MM-dd HH:mm:ss'),
                        remark: file.name
                    };
                    this.observationList.push(observation);
                }
            },
            handlerUpdateCreateTime(dateTime, index){
                this.observationList[index].createTime = dateTime;
            },
            handleUpdateRemark(remark, index){
                this.observationList[index].remark = remark;
            },
            clearItems(){
                this.observationList = [];
                this.$refs.fileToUpload.value = null;
            }
        },
        watch: {
            observationList: {
                handler() {
                    this.$emit("uploadChanged", this.observationList);
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .upload-select {
        padding: 10px;
        background: #f1f3f7;
        border-radius: 4px;
        margin-bottom:5px;
    }
    .upload-select .inputfile {
        color: #808080;
        cursor: pointer;
    }
    .upload-tip {
        display: block;
        font-size: small;
        color: grey;
    }
</style>
